import {ErrorCode, HttpStatus} from '@sollapay/enums';

import type {AssetType, TrustPurpose} from '@sollapay/enums';

/** No strategy registered for a `TrustPurpose` — the registry is out of sync with the enum. */
export class TrustTypeStrategyNotFoundError extends Error {
  readonly statusCode = HttpStatus.INTERNAL_SERVER_ERROR;
  readonly code = ErrorCode.INTERNAL_ERROR;

  constructor(purpose: TrustPurpose, options?: ErrorOptions) {
    super(`No trust type strategy registered for purpose "${purpose}"`, options);
    this.name = 'TrustTypeStrategyNotFoundError';
  }
}

/** No descriptor registered for an `AssetType` — the registry is out of sync with the enum. */
export class AssetTypeDescriptorNotFoundError extends Error {
  readonly statusCode = HttpStatus.INTERNAL_SERVER_ERROR;
  readonly code = ErrorCode.INTERNAL_ERROR;

  constructor(assetType: AssetType, options?: ErrorOptions) {
    super(`No descriptor registered for asset type "${assetType}"`, options);
    this.name = 'AssetTypeDescriptorNotFoundError';
  }
}
